<!-- 组件说明 -->
<template>
  <div class="con activity" v-if="loaded">
    <div v-if="type == 1 && list.length > 0">
      <div class="title">
        <h1><span>厂家</span>活动</h1>
        <p>factory activities</p>
        <i></i>
      </div>
      <div class="container">
        <div class="t">
          <div
            class="t-imgbox c-pointer"
            v-for="item in list"
            @click="toDetail(item.id)"
          >
            <img v-lazy="item.image" alt="" />
          </div>
        </div>
        <!-- <div class="b">
        <div class="b-imgbox c-pointer" v-for="item in list"  @click="toDetail(item.id)">
          <img v-lazy="item.image" alt="" :title="item.title" />
        </div>
      </div> -->
      </div>
    </div>

    <detail v-if="type == 2 && list.length > 0" :id="detailId"></detail>
    <div class="empty con" v-if="list.length == 0">
      <div class="empty-img">
        <img :src="require('@/assets/images/all_hd.png')" alt="" />
      </div>
      <div class="empty-con">
        <h5>暂无限时厂家活动</h5>
        <p>近期暂无限时厂家活动，请继续关注厂家活动</p>
      </div>
    </div>
    <!-- <qrcode v-if="type == 1" :top="352"></qrcode>
    <qrcode v-if="type == 2" :top="255"></qrcode> -->
  </div>
</template>

<script>
import detail from "./components/activities-detail";
import qrcode from "@/components/plugins/qrcode";
export default {
  components: { qrcode, detail },
  data() {
    return {
      list: [],
      type: 1,
      detailId: "",
      loaded: false,
    };
  },
  computed: {},
  methods: {
    toDetail(id) {
      this.type = 2;
      this.detailId = id;
      this.qrcodeTop = 256;
      // this.$router.push({ path:'/main/activitiesDetail',query:{id} })
    },
    getActivityList() {
      this.$api.GET_ACTIVITYLIST().then((res) => {
        if (res.status) {
          this.list = res.data;
          this.loaded = true;
        }
      });
    },
    changeType() {
      this.type = 1;
    },
  },
  mounted() {},
  created() {
    this.getActivityList();
  },
};
</script>

<style lang='scss' scoped>
.activity{
  min-height: calc(100vh - 315px);
}
.title {
  @include flex-d-c;
  align-items: center;
  margin: 40px 0 34px 0;
  h1 {
    font-size: 28px;
    color: #333333;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      font-weight: bold;
    }
    &::before {
      content: "";
      display: inline-block;
      width: 18px;
      height: 1px;
      background-color: #e2e2e2;
      line-height: 40px;
      margin-right: 36px;
    }
    &::after {
      content: "";
      display: inline-block;
      width: 18px;
      height: 1px;
      background-color: #e2e2e2;
      line-height: 40px;
      margin-left: 36px;
    }
  }

  p {
    font-size: 12px;
    text-transform: uppercase;
    color: #ccc;
    margin: 0 0 14px;
  }
  i {
    display: block;
    width: 30px;
    height: 4px;
    background-color: #fa4b4b;
  }
}
.container {
  margin-bottom: 40px;
}
.t {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .t-imgbox {
    height: 422px;
    width: 592px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    margin-bottom: 20px;
    img {
      @include size(100%, 100%);
    }
  }
}
.b {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .b-imgbox {
    height: 205px;
    width: 290px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #cccccc;
    margin-top: 12px;
    img {
      @include size(100%, 100%);
    }
  }
}
.empty {
  height: 260px;
  width: 1200px;
  background-color: #fdfdfd;
  border-radius: 10px;
  margin-top: 50px;
  @include flex-c;
  .empty-img {
    margin-right: 35px;
  }
  .empty-con {
    @include flex-d-c;
    h5 {
      font-size: 18px;
      color: #505050;
      margin-bottom: 22px;
    }
    p {
      font-size: 16px;
      color: #808080;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/activities/index.vue